/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';

import { LOCATION_PAGES } from './locations';

export const excludeMileagePath = (url) => url.split('/').filter((it) => (it && it !== 'mileage'));

export const transformLocationPath = (inputArray = []) => {
  const arr = [...inputArray];
  const hasLocation = arr.some((item) => LOCATION_PAGES.includes(item));

  if (hasLocation && arr[0] === 'sell-your-car') {
    arr[0] = 'sell-my-car';
  }

  return arr;
};

export const getURLPath = (str) => {
  const URLPathRegex = /http[s]*:\/\/[^/]+(\/.+)/;
  const matches = str.match(URLPathRegex);
  return matches[1];
};

export const isBlogURL = (url) => ((/^\/blog\/[0-9]{4}/).test(url));

export const isGuidesURL = (url) => ((/^\/sell-my-car\/guides\/(.*)/).test(url));

export const replaceHyphensWithSpace = (str) => str.replace(/-/g, ' ');

export const upperCaseString = (str = '') => str.charAt(0).toUpperCase() + str.slice(1);

export const getBlogTitle = (path) => {
  let blogPathName = 'Blog';
  const { params: { day, month, year } } = path;

  const formatDate = (date, end, pad) => {
    date = +date;
    const returnValue = (pad) ? '01' : null;
    return (!Number.isNaN(date) && date > 0 && date <= end) ? date.toString().padStart(2, 0) : returnValue;
  };

  const date = dayjs.utc([
    year || dayjs().year(),
    formatDate(month, 12, true), formatDate(day, 31, true),
  ].join('-'));

  if (year && !month) {
    blogPathName = year;
  } else if (month && !day) {
    blogPathName = date.format('MMMM');
  } else if (month && day) {
    blogPathName = date.format('dddd Do');
  }

  return blogPathName;
};
